
import { useState } from 'react';
import { Link } from 'react-router-dom';
import SuperAdminLayout from '../../../components/feature/SuperAdminLayout';

export default function SuperAdminCompanies() {
  const [companies] = useState([
    {
      id: 'COMP-001',
      name: '한국교육원',
      email: 'admin@koreaedu.com',
      registeredAt: '2024-01-15',
      plan: 'Pro',
      planPrice: 99000,
      templateCount: 8,
      totalCertificates: 1245,
      paidCertificates: 320,
      revenue: 3200000,
      status: 'active',
      lastLogin: '2024-01-20 14:30',
      adminName: '김관리',
      phone: '02-1234-5678'
    },
    {
      id: 'COMP-002',
      name: '디지털마케팅아카데미',
      email: 'admin@digitalmarketing.com',
      registeredAt: '2024-01-10',
      plan: 'Basic',
      planPrice: 29000,
      templateCount: 3,
      totalCertificates: 456,
      paidCertificates: 120,
      revenue: 1200000,
      status: 'active',
      lastLogin: '2024-01-19 09:15',
      adminName: '이교육',
      phone: '02-2345-6789'
    },
    {
      id: 'COMP-003',
      name: 'IT전문교육센터',
      email: 'admin@itedu.com',
      registeredAt: '2024-01-08',
      plan: 'Enterprise',
      planPrice: 0,
      templateCount: 15,
      totalCertificates: 3420,
      paidCertificates: 890,
      revenue: 8900000,
      status: 'active',
      lastLogin: '2024-01-20 16:45',
      adminName: '박기술',
      phone: '02-3456-7890'
    },
    {
      id: 'COMP-004',
      name: '비즈니스스쿨',
      email: 'admin@bizschool.com',
      registeredAt: '2024-01-05',
      plan: 'Pro',
      planPrice: 99000,
      templateCount: 10,
      totalCertificates: 2100,
      paidCertificates: 560,
      revenue: 5600000,
      status: 'active',
      lastLogin: '2024-01-18 11:20',
      adminName: '최경영',
      phone: '02-4567-8901'
    },
    {
      id: 'COMP-005',
      name: '온라인교육플랫폼',
      email: 'admin@onlineedu.com',
      registeredAt: '2024-01-03',
      plan: 'Free',
      planPrice: 0,
      templateCount: 2,
      totalCertificates: 89,
      paidCertificates: 0,
      revenue: 0,
      status: 'active',
      lastLogin: '2024-01-17 13:50',
      adminName: '정학습',
      phone: '02-5678-9012'
    },
    {
      id: 'COMP-006',
      name: '글로벌어학원',
      email: 'admin@globallang.com',
      registeredAt: '2023-12-28',
      plan: 'Basic',
      planPrice: 29000,
      templateCount: 4,
      totalCertificates: 678,
      paidCertificates: 180,
      revenue: 1800000,
      status: 'suspended',
      lastLogin: '2024-01-10 10:30',
      adminName: '한언어',
      phone: '02-6789-0123'
    },
    {
      id: 'COMP-007',
      name: '프로그래밍부트캠프',
      email: 'admin@codingcamp.com',
      registeredAt: '2023-12-20',
      plan: 'Pro',
      planPrice: 99000,
      templateCount: 9,
      totalCertificates: 1890,
      paidCertificates: 450,
      revenue: 4500000,
      status: 'active',
      lastLogin: '2024-01-20 15:10',
      adminName: '조코딩',
      phone: '02-7890-1234'
    },
    {
      id: 'COMP-008',
      name: '디자인아카데미',
      email: 'admin@designacademy.com',
      registeredAt: '2023-12-15',
      plan: 'Basic',
      planPrice: 29000,
      templateCount: 5,
      totalCertificates: 534,
      paidCertificates: 145,
      revenue: 1450000,
      status: 'active',
      lastLogin: '2024-01-19 14:25',
      adminName: '윤디자인',
      phone: '02-8901-2345'
    }
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [planFilter, setPlanFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortBy, setSortBy] = useState<'certificates' | 'date'>('date');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('desc');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [showLoginAsModal, setShowLoginAsModal] = useState(false);
  const [loginAsCompany, setLoginAsCompany] = useState<any>(null);

  const filteredCompanies = companies
    .filter(company => {
      const matchesSearch = company.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           company.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           company.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
                           company.adminName.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesPlan = planFilter === 'all' || company.plan === planFilter;
      const matchesStatus = statusFilter === 'all' || company.status === statusFilter;
      
      return matchesSearch && matchesPlan && matchesStatus;
    })
    .sort((a, b) => {
      let compareValue = 0;
      
      switch (sortBy) {
        case 'certificates':
          compareValue = a.totalCertificates - b.totalCertificates;
          break;
        case 'date':
          compareValue = new Date(a.registeredAt).getTime() - new Date(b.registeredAt).getTime();
          break;
      }
      
      return sortOrder === 'asc' ? compareValue : -compareValue;
    });

  const handleViewDetail = (company: any) => {
    setSelectedCompany(company);
    setShowDetailModal(true);
  };

  const handleLoginAs = (company: any) => {
    setLoginAsCompany(company);
    setShowLoginAsModal(true);
  };

  const confirmLoginAs = () => {
    if (loginAsCompany) {
      alert(`${loginAsCompany.name}의 관리자 계정으로 로그인합니다.\n기술 지원 모드가 활성화됩니다.`);
      // 실제로는 해당 고객의 관리자 대시보드로 이동
      window.REACT_APP_NAVIGATE('/admin-dashboard');
      setShowLoginAsModal(false);
    }
  };

  const getPlanColor = (plan: string) => {
    switch (plan) {
      case 'Free':
        return 'bg-gray-100 text-gray-800';
      case 'Basic':
        return 'bg-blue-100 text-blue-800';
      case 'Pro':
        return 'bg-purple-100 text-purple-800';
      case 'Enterprise':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'suspended':
        return 'bg-red-100 text-red-800';
      case 'trial':
        return 'bg-yellow-100 text-yellow-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'active':
        return '활성';
      case 'suspended':
        return '정지';
      case 'trial':
        return '체험';
      default:
        return '알 수 없음';
    }
  };

  const totalCertificates = filteredCompanies.reduce((sum, company) => sum + company.totalCertificates, 0);
  const totalPaidCertificates = filteredCompanies.reduce((sum, company) => sum + company.paidCertificates, 0);

  return (
    <SuperAdminLayout>
      <div className="min-h-screen bg-gray-50">
        {/* 헤더 */}
        <div className="bg-white border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-semibold text-gray-900">전체 고객 관리</h1>
                <p className="text-sm text-gray-500">모든 고객사의 정보를 조회하고 관리하세요</p>
              </div>
              <div className="flex items-center space-x-3">
                <button className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-file-excel-line mr-2"></i>
                  엑셀 다운로드
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-6 py-6">
        {/* 통계 요약 */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-building-line text-blue-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">총 고객사</p>
                <p className="text-xl font-semibold text-gray-900">{filteredCompanies.length}</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-file-text-line text-purple-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">총 발급 증명서</p>
                <p className="text-xl font-semibold text-gray-900">{totalCertificates.toLocaleString()}</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg border border-gray-200 p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-vip-crown-line text-orange-600"></i>
              </div>
              <div>
                <p className="text-sm text-gray-600">유료 증명서</p>
                <p className="text-xl font-semibold text-gray-900">{totalPaidCertificates.toLocaleString()}</p>
              </div>
            </div>
          </div>
        </div>

        {/* 필터 및 검색 */}
        <div className="bg-white rounded-lg border border-gray-200 p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">검색</label>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="고객사명, 이메일, 담당자명, ID"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">구독 플랜</label>
              <select
                value={planFilter}
                onChange={(e) => setPlanFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
              >
                <option value="all">전체</option>
                <option value="Free">Free</option>
                <option value="Basic">Basic</option>
                <option value="Pro">Pro</option>
                <option value="Enterprise">Enterprise</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">상태</label>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
              >
                <option value="all">전체</option>
                <option value="active">활성</option>
                <option value="suspended">정지</option>
                <option value="trial">체험</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">정렬</label>
              <div className="flex space-x-2">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value as any)}
                  className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 text-sm"
                >
                  <option value="date">가입일</option>
                  <option value="certificates">발급수</option>
                </select>
                <button
                  onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                  className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <i className={`ri-arrow-${sortOrder === 'asc' ? 'up' : 'down'}-line`}></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* 고객사 테이블 */}
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">고객사 ID</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">고객사명</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">담당자</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">가입일</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">구독 플랜</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">템플릿</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">발급 증명서</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">유료 증명서</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">상태</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 text-sm">액션</th>
                </tr>
              </thead>
              <tbody>
                {filteredCompanies.map((company) => (
                  <tr key={company.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="py-4 px-4 font-mono text-sm text-blue-600">{company.id}</td>
                    <td className="py-4 px-4">
                      <p className="font-medium text-gray-900">{company.name}</p>
                    </td>
                    <td className="py-4 px-4">
                      <p className="text-sm text-gray-900">{company.adminName}</p>
                    </td>
                    <td className="py-4 px-4 text-gray-600 text-sm">{company.registeredAt}</td>
                    <td className="py-4 px-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getPlanColor(company.plan)}`}>
                        {company.plan}
                      </span>
                    </td>
                    <td className="py-4 px-4 text-center">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                        {company.templateCount}개
                      </span>
                    </td>
                    <td className="py-4 px-4 text-center">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                        {company.totalCertificates.toLocaleString()}건
                      </span>
                    </td>
                    <td className="py-4 px-4 text-center">
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-800">
                        {company.paidCertificates.toLocaleString()}건
                      </span>
                    </td>
                    <td className="py-4 px-4">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(company.status)}`}>
                        {getStatusText(company.status)}
                      </span>
                    </td>
                    <td className="py-4 px-4">
                      <button
                        onClick={() => handleViewDetail(company)}
                        className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-blue-600 transition-colors cursor-pointer"
                        title="상세 정보"
                      >
                        <i className="ri-eye-line"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {filteredCompanies.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-building-line text-4xl text-gray-300 mb-4"></i>
              <p className="text-gray-500">조건에 맞는 고객사가 없습니다.</p>
            </div>
          )}
        </div>

        {/* 상세 정보 모달 */}
        {showDetailModal && selectedCompany && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto">
              <div className="p-6">
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900 mb-2">{selectedCompany.name}</h2>
                    <p className="text-gray-600">고객사 ID: {selectedCompany.id}</p>
                  </div>
                  <button
                    onClick={() => setShowDetailModal(false)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <i className="ri-close-line text-xl"></i>
                  </button>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">기본 정보</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">고객사명:</span>
                        <span className="font-medium">{selectedCompany.name}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">이메일:</span>
                        <span className="font-medium">{selectedCompany.email}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">담당자:</span>
                        <span className="font-medium">{selectedCompany.adminName}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">연락처:</span>
                        <span className="font-medium">{selectedCompany.phone}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">가입일:</span>
                        <span className="font-medium">{selectedCompany.registeredAt}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">최근 로그인:</span>
                        <span className="font-medium">{selectedCompany.lastLogin}</span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">구독 정보</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">구독 플랜:</span>
                        <span className={`font-medium px-2 py-1 rounded text-xs ${getPlanColor(selectedCompany.plan)}`}>
                          {selectedCompany.plan}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">월 구독료:</span>
                        <span className="font-medium">₩{selectedCompany.planPrice.toLocaleString()}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">상태:</span>
                        <span className={`font-medium px-2 py-1 rounded text-xs ${getStatusColor(selectedCompany.status)}`}>
                          {getStatusText(selectedCompany.status)}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-lg font-medium text-gray-900 mb-4">사용 현황</h3>
                    <div className="space-y-3">
                      <div className="flex justify-between">
                        <span className="text-gray-600">템플릿 수:</span>
                        <span className="font-medium">{selectedCompany.templateCount}개</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">총 발급 증명서:</span>
                        <span className="font-medium">{selectedCompany.totalCertificates.toLocaleString()}건</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">유료 증명서:</span>
                        <span className="font-medium">{selectedCompany.paidCertificates.toLocaleString()}건</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex space-x-3 mt-6 pt-6 border-t border-gray-200">
                  <button
                    onClick={() => {
                      setShowDetailModal(false);
                      handleLoginAs(selectedCompany);
                    }}
                    className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-login-box-line mr-2"></i>
                    고객사로 로그인
                  </button>
                  <button className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-mail-line mr-2"></i>
                    이메일 발송
                  </button>
                  <button className="flex-1 border border-red-300 text-red-600 py-2 px-4 rounded-lg hover:bg-red-50 transition-colors cursor-pointer whitespace-nowrap">
                    <i className="ri-pause-circle-line mr-2"></i>
                    계정 정지
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* 고객사로 로그인 확인 모달 */}
        {showLoginAsModal && loginAsCompany && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg max-w-md w-full">
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-login-box-line text-2xl text-green-600"></i>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-900">고객사로 로그인</h2>
                    <p className="text-gray-600">기술 지원 모드로 전환합니다</p>
                  </div>
                </div>

                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                  <h4 className="font-medium text-blue-900 mb-2">로그인 정보</h4>
                  <div className="text-sm text-blue-800 space-y-1">
                    <p><strong>고객사:</strong> {loginAsCompany.name}</p>
                    <p><strong>담당자:</strong> {loginAsCompany.adminName}</p>
                    <p><strong>이메일:</strong> {loginAsCompany.email}</p>
                  </div>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
                  <h4 className="font-medium text-yellow-900 mb-2">주의사항</h4>
                  <div className="text-sm text-yellow-800 space-y-1">
                    <p>• 고객사의 모든 데이터에 접근할 수 있습니다</p>
                    <p>• 수정 작업은 신중하게 진행해주세요</p>
                    <p>• 모든 활동이 로그에 기록됩니다</p>
                    <p>• 작업 완료 후 반드시 로그아웃하세요</p>
                  </div>
                </div>

                <div className="flex space-x-3">
                  <button
                    onClick={() => setShowLoginAsModal(false)}
                    className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    취소
                  </button>
                  <button
                    onClick={confirmLoginAs}
                    className="flex-1 bg-green-600 text-white py-2 px-4 rounded-lg hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-login-box-line mr-2"></i>
                    로그인
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </SuperAdminLayout>
  );
}
